import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSiteListRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Monitoring/GetSiteList`
});

export const GetSiteReportRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Monitoring/GetSiteReport`,
	params: { siteId }
});

export const GetSiteReportEmailRequest = (siteId, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Monitoring/GetSiteReportEmail`,
	params: { siteId, userId }
});

export const GetSiteReportEmailAcceptanceRequest = (siteId, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Monitoring/GetSiteReportEmailAcceptance`,
	params: { siteId, userId }
});

export const GetSiteReportExcelRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Monitoring/GetSiteReportExcel`,
	params: { siteId }
});
